// @flow

import type { State } from "@store/reducers";

export * from "./absence-reasons";
export * from "./absence-review";
export * from "./alerts";
export * from "./employee-absences";
export * from "./employee-events";
export * from "./employee-notifications";
export * from "./employee-positions";
export * from "./hierarchy";
export * from "./shift-patterns";
export * from "./special-contact-types";
export * from "./staff-groups";
export * from "./home";

// Common selectors! Not related to above, but really common
export const selectEmployeeList = (state: State) => state.shared.selectEmployee.employeeList;

export const getSelectedEmployee = (state: State) => state.shared.selectEmployee.selectedEmployee;

export const selectEmployeePositionsList = (state: State) =>
  state.shared.selectEmployee.employeePositionsList;

export const getSelectedEmployeePosition = (state: State) =>
  state.shared.selectEmployee.selectedEmployeePosition;

export const selectEmployeeFilters = (state: State) =>
  (state.form["select-employee-filter"] || {}).values || {};

export const isLoading = (state: State) => {
  const employeeAbsences = !!(state.shared.employeeAbsences || {}).requestsInProgress;
  const eventsLoading = !!(state.shared.employeeEvents || {}).requestsInProgress;
  const notificationsLoading = !!(state.shared.employeeNotifications || {}).requestsInProgress;
  const selectEmployeesLoading = !!state.shared.selectEmployee.requestsInProgress;

  return eventsLoading || notificationsLoading || selectEmployeesLoading || employeeAbsences;
};
